import React from 'react';
import axios from 'axios';
import {Button, Form, FormControl, FormGroup, HelpBlock} from 'react-bootstrap';
import {withRouter} from "react-router-dom";

import './style.css';

class ResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            values: {
                password: '',
                passwordConfirm: '',
            },
            validation: {
                states: {
                    password: null,
                },
                messages: {
                    password: '',
                }
            },
            inProcess: false,
            done: false
        };

        this.requestReset = this.requestReset.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangePasswordConfirm = this.handleChangePasswordConfirm.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].classList.remove('nav-md');
        document.getElementsByTagName('body')[0].classList.add('login');
    }

    componentWillUnmount() {
        document.getElementsByTagName('body')[0].classList.remove('login');
        document.getElementsByTagName('body')[0].classList.add('nav-md');
    }

    handleChangePassword(event) {
        let password =  event ? event.target.value : this.state.values.password;

        let values = this.state.values;
        values.password = password;

        let validation = this.state.validation;
        if (password && password.length >= 6) {
            validation.states.password = "success";
            validation.messages.password = '';

        } else {
            validation.states.password = "error";
            validation.messages.password = 'Velikost hesla musí být alesponň 6 znaků!';
        }

        this.setState({
            values,
            validation
        });
    }

    handleChangePasswordConfirm(event) {
        let password = this.state.values.password;
        let passwordConfirm = event ? event.target.value : this.state.values.passwordConfirm;

        let values = this.state.values;
        values.passwordConfirm = passwordConfirm;

        let validation = this.state.validation;

        if (password === passwordConfirm) {
            validation.states.password = "success";
            validation.messages.password = ''
        } else {
            validation.states.password = "error";
            validation.messages.password = 'Hesla se neshodují!';
        }
        this.setState({
            values,
            validation
        });
    }

    isValid() {
        this.handleChangePassword();
        this.handleChangePasswordConfirm();

        let {validation} = this.state;

        return (Object.values(validation.states).indexOf("error") < 0);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()) {
            this.requestReset(this.state.values);
        }
    }

    requestReset(data) {
        this.setState({
            inProcess: true,
            done: false
        });
        axios.put(this.props.api.resetPassword, {
            token: this.props.match.params.resetToken,
            password: data.password,
        }).then((res) => {
            console.log('Uloženo!', res);
            this.setState({
                inProcess: false,
                done: true
            });
        }).catch((error) => {
            console.error('Error axios:', error);
            alert('Chyba komunikace. Opakujte akci později.');
            this.setState({
                inProcess: false,
                done: false
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {}
    componentWillReceiveProps(nextProps) {}

    render() {
        const {done, inProcess, values, validation} = this.state;
        return (
            <div className="login-wrapper">
                <div className="animate form login-form">
                    <section className="login-content">
                        <Form onSubmit={this.handleSubmit}>
                            <h1>Reset hesla</h1>
                            <div id="sending" className={inProcess && !done ? "show" : "hide"}>
                                odesílání...
                            </div>
                            <div id="sent" className={done ? "show" : "hide"}>
                                Nové heslo bylo nastaveno, pokračujte na <a href="https://www.nebouram.cz">stránku přihlášení</a>
                            </div>
                            <div className={inProcess || done ? "hide" : "show"}>
                                <FormGroup controlId="formValidationError1" validationState={validation.states.password}>
                                    <FormControl type="password" ref="password" onChange={this.handleChangePassword} value={values.password} placeholder="Zadejte nové heslo"/>
                                </FormGroup>
                                <FormGroup controlId="formValidationError1" validationState={validation.states.password}>
                                    <FormControl type="password" ref="passwordConfirm" onChange={this.handleChangePasswordConfirm} value={values.passwordConfirm} placeholder="Zadejte heslo znovu"/>
                                    <HelpBlock>{validation.messages.password}</HelpBlock>
                                </FormGroup>
                            </div>
                            <Button type='submit' className={done ? "hide" : "show-inline"} bsStyle="success">Resetovat heslo</Button>
                            <div className="separator">
                                <div>
                                    <h1>
                                        <i className="fa fa-paw"/>
                                        {' '}
                                        Nebourám.cz
                                    </h1>
                                    <p>©{new Date().getFullYear()} Všechna práva vyhrazena. Nebourám.cz</p>
                                </div>
                            </div>
                        </Form>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(ResetPasswordForm);


/** WEBPACK FOOTER **
 ** ./src/containers/ForgottenPassword/ResetPasswordForm.js
 **/